import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./oktah-neue-var.ttf%22,%22variable%22:%22--font-oktah-neue%22,%22weight%22:%2215%20190%22}],%22variableName%22:%22oktah%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'oktah', 'oktah Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
